import "../../../pages/order-form/OrderForm.css";
import { Col, Row } from "react-bootstrap";
import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { Button } from "@app/components";
import { getStudentProposeOrderDetailsById, orderAvailableSet, updateOrderSetStatus } from "@app/services/order";
import { useNavigate, useParams } from "react-router-dom";
import moment from "moment";
import { confirmAlert } from "react-confirm-alert";

const ViewStudentProposeOrderDetails = () => {

	let obj: any = {}
	let { id } = useParams();
	const navigate = useNavigate();
	const [isLoading, setLoading] = useState(false);
	const [orderDetails, setOrderDetails] = useState(obj);

	useEffect(() => {
        getStudentProposeOrderDetails(id);
    },[]);

	const getStudentProposeOrderDetails = async (id) => {
        try {
            setLoading(true);
            const resp = await getStudentProposeOrderDetailsById(id);
            if (resp?.success === true) {
				setLoading(false);
				setOrderDetails(resp?.collections)
            } else {
				setLoading(false);
                toast.error(resp?.errors[0]?.msg);
            }
        } catch (error: any) {
            setLoading(false);
            toast.error(error?.message || 'Internal Server Error');
        }
    };

	const confirm = (e, title, message, setId, status) => {
		confirmAlert({
			title: title,
			message: message,
			buttons: [{
						label: 'Yes',
						onClick: () => status == '' ? orderAvailableSetAPI({student_work_order_id: id, set_id: setId}) : updateOrderSetStatusAPI({student_work_order_id: id, set_id: setId, status: status})
					},
					{
						label: 'No',
						onClick: () => {}
					}]
		});
		e.preventDefault();
	};

	const updateOrderSetStatusAPI = async (payload) => {
		try {
			setLoading(true);
			const resp = await updateOrderSetStatus(payload);
			if(resp.success === true){
				setLoading(false)
				toast.success(resp?.message)
				getStudentProposeOrderDetails(id)
			}else{
				toast.error(resp?.errors[0]?.msg);
				setLoading(false);
			}
		} catch (error: any) {
			setLoading(false);
			toast.error(error?.message || 'Internal Server Error');
		}
	};

	const orderAvailableSetAPI = async (payload) => {
		try {
			setLoading(true);
			const resp = await orderAvailableSet(payload);
			if(resp.success === true){
				setLoading(false)
				toast.success(resp?.message)
				getStudentProposeOrderDetails(id)
			}else{
				toast.error(resp?.errors[0]?.msg);
				setLoading(false);
			}
		} catch (error: any) {
			setLoading(false);
			toast.error(error?.message || 'Internal Server Error');
		}
	};

	return (
		<>
		<div className="container-fluid">
			<div className="row">
				<div className="col-md-12 col-lg-12 col-xl-12">
					<div className="card card-primary">
						<div className="card-header"><h3 className="card-title">Propose Material Order Details</h3></div>
						<div className="card-body">
							<div className="content">
								<div className="row">
									<div className="col-sm-4">
										<div className="form-group">
											<dt>Student</dt>
											<dd>{ orderDetails?.student_name ?? '---' }</dd>
										</div>
									</div>
									<div className="col-sm-4">
										<div className="form-group">
											<dt>Franchise</dt>
											<dd>{ orderDetails?.franchise_name ?? '---' }</dd>
										</div>
									</div>
									<div className="col-sm-4">
										<div className="form-group">
											<dt>Centre</dt>
											<dd>{ orderDetails?.centre_name ?? '---' }</dd>
										</div>
									</div>
									<div className="col-sm-4">
										<div className="form-group">
											<dt>Subject</dt>
											<dd>{ orderDetails?.subject_name == 'mix_match' ? 'Mix and Match' : orderDetails?.subject_name }</dd>
										</div>
									</div>
									<div className="col-sm-4">
										<div className="form-group">
											<dt>Status</dt>
											<dd>{ orderDetails?.status_label ?? '---' }</dd>
										</div>
									</div>
									<div className="col-sm-4">
										<div className="form-group">
											<dt>Created On </dt>
											<dd>{orderDetails?.created_at ? moment(orderDetails?.created_at).format('DD-MM-YYYY') : '---'}</dd>
										</div>
									</div>
								</div>
								<hr/>
								{ orderDetails?.details?.mix_match !== undefined && (
									<div className="content_inner_wrap" key={3}>
										<Row>
											<Col xl={12}>
												<b>Mix and Match</b>
											</Col>
											<Col xl={12}>
												<div className="list_module_wrapper">
													<Row>
														<Col xl={6}>
															<h6 className="mb-4 grey_wrapper_title">
																New Modules
															</h6>
															{ (orderDetails.details?.mix_match?.proposed).length > 0 && (
																<table className="table table-bordered" id="client_id_table">
																	<tbody>
																		<tr className='text-center'>
																			<th> Module Name</th>
																			<th> Set</th>
																			<th> Action</th>
																		</tr>
																		{ (orderDetails.details?.mix_match?.proposed).map((item, i) => (
																			<tr className='text-center' key={i}>
																				<td> { item?.set_name }</td>
																				<td> { `${item?.from_worksheet} - ${item?.to_worksheet}` } </td>
																				<td> 
																					{ item?.status == 'active' ? (
																						<a href="#" className="badge badge-danger" onClick={ (e) => confirm(e, 'Remove Set!', 'Are you sure you want to remove this set?', item?.set_id, 'removed')}>Remove</a>
																					) :(
																						<span className="badge badge-secondary"> Removed </span>
																					)}
																				</td>
																			</tr>
																		))}
																	</tbody>
																</table>
															)}
														</Col>
														<Col xl={6}>
															<h6 className="mb-4 grey_wrapper_title">
																Available Worksheets  
																<small> (You might have from previous order, reorder if lost or used)</small>
															</h6>
															{ (orderDetails.details?.mix_match?.previous_order_available).length > 0 ? (
																<table className="table table-bordered" id="client_id_table">
																	<tbody>
																		<tr className='text-center'>
																			<th> Module Name</th>
																			<th> Set</th>
																			<th> Worksheet(s)</th>
																			<th> Action</th>
																		</tr>
																		{ (orderDetails.details?.mix_match?.previous_order_available).map((item, i) => (
																			<tr className='text-center' key={i}>
																				<td> { item?.set_name }</td>
																				<td> { `${item?.from_worksheet} - ${item?.to_worksheet}` } </td>
																				<td>
																					{(item?.available_worksheets).length > 0 ? ( Array.prototype.map.call(item?.available_worksheets, function(ws) { return ws; }).join(", ") ) : ''}
																				</td>
																				<td> 
																					<a href="#" className="badge badge-success" onClick={ (e) => confirm(e, 'Add Set!', 'Are you sure you want to add this set?', item?.set_id, '')}>I still want to order new</a>
																				</td>
																			</tr>
																		))}
																	</tbody>
																</table>
															) : (
																<div className="content_inner_wrap"> 
																	No previous worksheets available.
																</div>
															)}
														</Col>
													</Row>
												</div>
											</Col>
										</Row>
									</div>
								)}
								{ orderDetails?.details?.english !== undefined && (
									<div className="content_inner_wrap" key={4}>
										<Row>
											<Col xl={12}>
												<b>English</b>
											</Col>
											<Col xl={12}>
												<div className="list_module_wrapper">
													<Row>
														<Col xl={6}>
															<h6 className="mb-4 grey_wrapper_title">
																New Modules
															</h6>
															{ (orderDetails.details?.english?.proposed).length > 0 && (
																<table className="table table-bordered" id="client_id_table">
																	<tbody>
																		<tr className='text-center'>
																			<th> Module Name</th>
																			<th> Set</th>
																			<th> Action</th>
																		</tr>
																		{ (orderDetails.details?.english?.proposed).map((item, i) => (
																			<tr className='text-center' key={i}>
																				<td> { item?.set_name }</td>
																				<td> { `${item?.from_worksheet} - ${item?.to_worksheet}` } </td>
																				<td> 
																					{ item?.status == 'active' ? (
																						<a href="#" className="badge badge-danger" onClick={ (e) => confirm(e, 'Remove Set!', 'Are you sure you want to remove this set?', item?.set_id, 'removed')}>Remove</a>
																					) :(
																						<span className="badge badge-secondary"> Removed </span>
																					)}
																				</td>
																			</tr>
																		))}
																	</tbody>
																</table>
															)}
														</Col>
														<Col xl={6}>
															<h6 className="mb-4 grey_wrapper_title">
																Available Worksheets  
																<small> (You might have from previous order, reorder if lost or used)</small>
															</h6>
															{ (orderDetails.details?.english?.previous_order_available).length > 0 ? (
																<table className="table table-bordered" id="client_id_table">
																	<tbody>
																		<tr className='text-center'>
																			<th> Module Name</th>
																			<th> Set</th>
																			<th> Worksheet(s)</th>
																			<th> Action</th>
																		</tr>
																		{ (orderDetails.details?.english?.previous_order_available).map((item, i) => (
																			<tr className='text-center' key={i}>
																				<td> { item?.set_name }</td>
																				<td> { `${item?.from_worksheet} - ${item?.to_worksheet}` } </td>
																				<td>
																					{(item?.available_worksheets).length > 0 ? ( Array.prototype.map.call(item?.available_worksheets, function(ws) { return ws; }).join(", ") ) : ''}
																				</td>
																				<td> 
																					<a href="#" className="badge badge-success" onClick={ (e) => confirm(e, 'Add Set!', 'Are you sure you want to add this set?', item?.set_id, '')}>I still want to order new</a>
																				</td>
																			</tr>
																		))}
																	</tbody>
																</table>
															) : (
																<div className="content_inner_wrap"> 
																	No previous worksheets available.
																</div>
															)}
														</Col>
													</Row>
												</div>
											</Col>
										</Row>
									</div>
								)}
								{ orderDetails?.details?.science !== undefined && (
									<div className="content_inner_wrap" key={4}>
										<Row>
											<Col xl={12}>
												<b>Science</b>
											</Col>
											<Col xl={12}>
												<div className="list_module_wrapper">
													<Row>
														<Col xl={6}>
															<h6 className="mb-4 grey_wrapper_title">
																New Modules
															</h6>
															{ (orderDetails.details?.science?.proposed).length > 0 && (
																<table className="table table-bordered" id="client_id_table">
																	<tbody>
																		<tr className='text-center'>
																			<th> Module Name</th>
																			<th> Set</th>
																			<th> Action</th>
																		</tr>
																		{ (orderDetails.details?.science?.proposed).map((item, i) => (
																			<tr className='text-center' key={i}>
																				<td> { item?.set_name }</td>
																				<td> { `${item?.from_worksheet} - ${item?.to_worksheet}` } </td>
																				<td> 
																					{ item?.status == 'active' ? (
																						<a href="#" className="badge badge-danger" onClick={ (e) => confirm(e, 'Remove Set!', 'Are you sure you want to remove this set?', item?.set_id, 'removed')}>Remove</a>
																					) :(
																						<span className="badge badge-secondary"> Removed </span>
																					)}
																				</td>
																			</tr>
																		))}
																	</tbody>
																</table>
															)}
														</Col>
														<Col xl={6}>
															<h6 className="mb-4 grey_wrapper_title">
																Available Worksheets  
																<small> (You might have from previous order, reorder if lost or used)</small>
															</h6>
															{ (orderDetails.details?.science?.previous_order_available).length > 0 ? (
																<table className="table table-bordered" id="client_id_table">
																	<tbody>
																		<tr className='text-center'>
																			<th> Module Name</th>
																			<th> Set</th>
																			<th> Worksheet(s)</th>
																			<th> Action</th>
																		</tr>
																		{ (orderDetails.details?.science?.previous_order_available).map((item, i) => (
																			<tr className='text-center' key={i}>
																				<td> { item?.set_name }</td>
																				<td> { `${item?.from_worksheet} - ${item?.to_worksheet}` } </td>
																				<td>
																					{(item?.available_worksheets).length > 0 ? ( Array.prototype.map.call(item?.available_worksheets, function(ws) { return ws; }).join(", ") ) : ''}
																				</td>
																				<td> 
																					<a href="#" className="badge badge-success" onClick={ (e) => confirm(e, 'Add Set!', 'Are you sure you want to add this set?', item?.set_id, '')}>I still want to order new</a>
																				</td>
																			</tr>
																		))}
																	</tbody>
																</table>
															) : (
																<div className="content_inner_wrap"> 
																	No previous worksheets available.
																</div>
															)}
														</Col>
													</Row>
												</div>
											</Col>
										</Row>
									</div>
								)}
								{ orderDetails?.details?.mathematics !== undefined && (
									<div className="content_inner_wrap" key={4}>
										<Row>
											<Col xl={12}>
												<b>Mathematics</b>
											</Col>
											<Col xl={12}>
												<div className="list_module_wrapper">
													<Row>
														<Col xl={6} className="mb-4">
															<h6 className="mb-4 grey_wrapper_title">
																New Modules
															</h6>
															{ (orderDetails.details?.mathematics?.proposed).length > 0 && (
																<table className="table table-bordered" id="client_id_table">
																	<tbody>
																		<tr className='text-center'>
																			<th> Module Name</th>
																			<th> Set</th>
																			<th> Action</th>
																		</tr>
																		{ (orderDetails.details?.mathematics?.proposed).map((item, i) => (
																			<tr className='text-center' key={i}>
																				<td> { item?.set_name }</td>
																				<td> { `${item?.from_worksheet} - ${item?.to_worksheet}` } </td>
																				<td> 
																					{ item?.status == 'active' ? (
																						<a href="#" className="badge badge-danger" onClick={ (e) => confirm(e, 'Remove Set!', 'Are you sure you want to remove this set?', item?.set_id, 'removed')}>Remove</a>
																					) :(
																						<span className="badge badge-secondary"> Removed </span>
																					)}
																				</td>
																			</tr>
																		))}
																	</tbody>
																</table>
															)}
														</Col>
														<Col xl={6}>
															<h6 className="mb-4 grey_wrapper_title">
																Available Worksheets  
																<small> (You might have from previous order, reorder if lost or used)</small>
															</h6>
															{ (orderDetails.details?.mathematics?.previous_order_available).length > 0 ? (
																<table className="table table-bordered" id="client_id_table">
																	<tbody>
																		<tr className='text-center'>
																			<th> Module Name</th>
																			<th> Set</th>
																			<th> Worksheet(s)</th>
																			<th> Action</th>
																		</tr>
																		{ (orderDetails.details?.mathematics?.previous_order_available).map((item, i) => (
																			<tr className='text-center' key={i}>
																				<td> { item?.set_name }</td>
																				<td> { `${item?.from_worksheet} - ${item?.to_worksheet}` } </td>
																				<td>
																					{(item?.available_worksheets).length > 0 ? ( Array.prototype.map.call(item?.available_worksheets, function(ws) { return ws; }).join(", ") ) : ''}
																				</td>
																				<td> 
																					<a href="#" className="badge badge-success" onClick={ (e) => confirm(e, 'Add Set!', 'Are you sure you want to add this set?', item?.set_id, '')}>I still want to order new</a>
																				</td>
																			</tr>
																		))}
																	</tbody>
																</table>
															) : (
																<div className="content_inner_wrap"> 
																	No previous worksheets available.
																</div>
															)}
														</Col>
													</Row>
												</div>
											</Col>
										</Row>
									</div>
								)}
							</div>
						</div>
						<div className="card-footer">
							<Button type="button" isLoading={isLoading} onClick={() => navigate(-1)} className="btn btn-default "> Back </Button>
						</div>
					</div>
				</div>
			</div>
		</div>
		</>
	);
};

export default ViewStudentProposeOrderDetails;